<template>
    <!-- Tarefas -->
    <div v-if="tarefas && tarefas.length" class="mb-4">
        <div class="card carde mb-2 w3-animate-opacity">
            <div class="card-body p-3 alert-warning">
                <div class="row">
                    <div class="col col-12 col-md-10">
                    <h5>
                        <span class="badge badge-secondary">{{ tarefas.length }}</span>
                        <small class="ml-2">{{ tarefas.length == 1 ? 'pendência' : 'pendências' }}</small>
                    </h5>
                    <ul class="mb-0">
                        <li v-for="(tarefa, itx) in lista_tarefas" :key="itx">
                        {{ tarefa.st_descricao }}
                        </li>
                        <li v-if="tarefas.length > 2">
                        <span class="badge badge-secondary">
                            <i class="fas fa-ellipsis-h"></i>
                        </span>
                        </li>
                    </ul>
                    </div>
                    <div class="col col-12 col-md-2 text-right">
                    <button type="button" class="btn btn-dark" @click="$router.push({ name: 'tarefas'})">
                        Acessar
                    </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    props: ['tarefas'],

    computed: { 
        lista_tarefas: function () { 
            return _.slice(this.tarefas, 0, 2);
        },
    }
}
</script>